// extracted by mini-css-extract-plugin
export var connectionButton = "_97-1";
export var rightPanel = "_97-3";
export var stepDescription = "_97-2";
export var stepIcon = "_97-0";